import type { Company } from '../companies/company';

export type SelectItem = {
  value: number;
  label: string;
};

export function fromCompany(companies: Array<Company>): Array<SelectItem> {
  return companies.map(company => ({
    value: company.id,
    label: company.name,
  }));
}
